export function createImportanceRulerConfig() {
	return {
		title: "Importance Ruler",
		focus: "reducing evening alcohol use",
		focusLabel: "Change",
		completeLabel: "Complete importance response",
		partialLabel: "Partial importance response",
		historyLabel: "Earlier importance ratings for this change",
		differenceLabel: "Change since previous rating",
		instructions: "Think about this change and choose how important it feels right now. Then describe why it matters or does not matter to you.",
		ratingScaleMax: 10,
		middleAnchor: "SOMEWHAT",
		ratingFieldId: "importance",
		headlineFieldId: "importance",
		reasonFieldId: "reasons",
		fixedPromptSequence: true,
		validateFormAnswers: true,
		allowEmptyFields: true,
		rejectEmptyFormSubmission: true,
		rejectBlankRequiredText: true,
		requireFocus: true,
		requireAnyAnswer: true,
		requirePairedRatingAndTextFields: true,
		fields: [
			{id: "importance", type: "SCALE", title: "How important is this change to you right now?", min: 0, max: 10, lowLabel: "NOT", highLabel: "VERY", isRequired: true},
			{id: "reasons", type: "MULTILINE", title: "Why does this change matter or not matter to you? What personal reasons or values connect to your answer?", isRequired: true},
		],
	}
}

export function createImportanceRulerDemoPayload() {
	return {answers: {importance: 7, reasons: "I want to feel rested when I take my daughter to school."}}
}
